import { useMemo } from 'react';
import { useGeoCustomization } from './useGeoCustomization';
import countryList from '../constants/countryList';

/**
 * Utility Hook to return a available countries list
 * @param filterRestrictedCountries - If true, filters out restricted countries based on Partner Geo Customization preferences
 * @returns
 */
export function useAvailableCountryList(filterRestrictedCountries = true) {
  const {
    isLoading,
    geoCustomization: { restrictedCountries },
  } = useGeoCustomization();

  return useMemo(() => {
    // return empty list customizations are loading, and we are filtering restricted countries
    if (isLoading && filterRestrictedCountries) {
      return [];
    }

    // return all the countries if there is no filtering required
    if (!filterRestrictedCountries) {
      return countryList;
    }

    const restrictedCountryCodes = new Set(restrictedCountries.map((country) => country.toUpperCase()));
    return countryList.filter((country) => !restrictedCountryCodes.has(country.value));
  }, [isLoading, restrictedCountries, filterRestrictedCountries]);
}
